import { render, staticRenderFns } from "./IssueTypeRow.vue?vue&type=template&id=3ffe342e&scoped=true&"
import script from "./IssueTypeRow.vue?vue&type=script&lang=ts&"
export * from "./IssueTypeRow.vue?vue&type=script&lang=ts&"
import style0 from "./IssueTypeRow.vue?vue&type=style&index=0&id=3ffe342e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ffe342e",
  null
  
)

export default component.exports